import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form, FormGroup, InputGroupText } from 'reactstrap';
import {
  isRequired,
  validateNumber,
} from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import CountrySelect from '../../../common/forms/select/CountrySelect';
import FormFooter from '../../../common/forms/FormFooter';
import Loader from '../../../common/Loader';

export const SalesTaxForm = ({ handleSubmit, loading }) =>
  loading ? (
    <Loader />
  ) : (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="País" required>
          <Field
            name="countryId"
            component={CountrySelect}
            validate={[isRequired]}
            placeholder="Ingresa mínimo 4 caracteres"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Porcentaje de Imputesto" required>
          <Field
            name="taxRate"
            component={TextInput}
            type="text"
            placeholder="Porcentaje Impuesto"
            append={<InputGroupText>%</InputGroupText>}
            validate={[isRequired, validateNumber]}
          />
        </FormItem>
      </FormGroup>
      <FormFooter />
    </Form>
  );

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: !AccountingUnit.SalesTax.getIn(['current', 'activity']).isEmpty(),
});

SalesTaxForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

SalesTaxForm.defaultProps = {
  loading: false,
};

const formComponent = reduxForm({
  form: 'SalesTaxForm',
})(SalesTaxForm);

export default connect(mapStateToProps)(formComponent);
